import { parseWaMessageKey } from '@bt-common/utils/message-key';
import { ContentMessageServiceActions } from '@extension/context/content/services/contentMessageServiceActions';

/** A jid from a WAWeb wid (`_serialized`, else `user@server`) or a string. */
const jidOf = (wid: any): string | undefined =>
    typeof wid === 'string' ? wid
        : wid?._serialized ?? (wid?.user && wid?.server ? `${wid.user}@${wid.server}` : undefined);

/**
 * The open reply box's quote, kept only for a single-recipient message to the
 * quoted message's own chat (QA 3b E6 / E6-R). `openReply` is the compose box's
 * quoted MsgKey spread (`checkIfReplyingToMessage`): on current WhatsApp Web it
 * has no `_serialized`, so the chat is its `remote` wid. A @lid / @c.us spelling
 * difference is resolved through the engine's lid → phone conversion.
 */
export async function replyForRecipient<T>(openReply: T | null | undefined, contactList: Array<{ id?: string }> | undefined): Promise<T | null> {
    const recipient = contactList?.length === 1 ? contactList[0]?.id : undefined;
    const reply: any = openReply;
    if (!reply || !recipient) return null;
    const replyChat = jidOf(reply.remote) ?? (reply._serialized ? parseWaMessageKey(reply._serialized)?.remoteJid : undefined);
    if (!replyChat) return null;
    if (replyChat === recipient) return openReply!;
    if (!replyChat.endsWith('@lid') && !recipient.endsWith('@lid')) return null;
    const toPhone = async (jid: string) =>
        jid.endsWith('@lid') ? (await ContentMessageServiceActions.convertWaLidSerializedToCusSerialized(jid)) ?? jid : jid;
    return (await toPhone(replyChat)) === (await toPhone(recipient)) ? openReply! : null;
}
